// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"194fe479","455":"32c9c729"}[chunkId] + ".chunk.js";
};